import axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import { FaFileInvoice } from 'react-icons/fa'
import { useSelector } from 'react-redux'
import Loading from '../../components/Display/Loading'
import Modal from '../../components/Display/Modal'
import { HeaderProps } from '../../components/Layout/Header'
import { ThemeContext } from '../../context/ThemeContext'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { RootState } from '../../redux/store'
import { dateToDB, formatPipe } from '../../utils/utils'
import AddSuscriberForm from './AddSuscriberForm'
import SuscriptionCard from './SuscriptionCard'
import SuscriptionForm from './SuscriptionForm'
import SuscriptionView from './SuscriptionView'

const server = process.env.REACT_APP_SERVER_URL

export interface ISuscription {
  id: string
  frequency: 'monthly' | 'weekly' | 'biweekly' | 'quarterly' | 'annual'
  total: string
  items: any[]
  discount: string
  description: string
  active: boolean
  duration: number
  emailTitle: string
  emailBody: string
  c2PEnabled: boolean
  ivaType: 'GENERAL' | 'REDUCED' | 'EXEMPT'
}

const Suscriptions: React.FC<SuscriptionsProps> = ({ setHeaderActions }) => {
  const [modal, setModal] = useState(false)
  const [viewModal, setViewModal] = useState(false)

  const [isLoadingForm, setIsLoadingForm] = useState<boolean>(false)

  const [loadingSuscription, setLoadingSuscription] = useState<boolean>(false)

  const { addAlert } = useSnackBars()
  const { theme } = useContext(ThemeContext)

  const user = useSelector((state: RootState) => state.auth.user)
  const userRole = user?.['custom:user_role']
  const userPlan = user?.['custom:user_plan']
  const isEmprendedorUser =
    userPlan === 'emprendedor' || userPlan === 'estudiantil'

  const [suscriptions, setSuscriptions] = useState<ISuscription[]>([])

  const [loadingSubscriber, setLoadingSubscriber] = useState<boolean>(false)

  const [selectedSuscription, setSelectedSuscription] =
    useState<ISuscription | null>(null)

  const [selectedSuscriptionToView, setSelectedSuscriptionToView] =
    useState<ISuscription | null>(null)

  const [addSubscriberModal, setAddSubscriberModal] = useState<boolean>(false)

  const [
    selectedSuscriptionToAddSubscriber,
    setSelectedSuscriptionToAddSubscriber,
  ] = useState<any | null>(null)

  useEffect(() => {
    // No mostrar acciones si es plan emprendedor
    if (isEmprendedorUser) {
      setHeaderActions({})
    } else {
      setHeaderActions({
        addAction:
          userRole === 'cashier'
            ? undefined
            : () => {
                setModal(true)
              },
      })
    }
    return () => {
      setHeaderActions(null)
    }
    //eslint-disable-next-line
  }, [setHeaderActions, userRole, isEmprendedorUser])

  const onSubmit = async (values: any) => {
    console.log(
      '🚀 [Suscriptions] ============ SUBMIT RECIBIDO DEL FORM ============'
    )
    console.log('🚀 [Suscriptions] values received:', values)
    console.log('🚀 [Suscriptions] values.items:', values.items)
    console.log('🚀 [Suscriptions] values.items.length:', values.items?.length)
    console.log('🚀 [Suscriptions] selectedSuscription:', selectedSuscription)

    setIsLoadingForm(true)
    try {
      const baseBody = {
        ...values,
        total: +formatPipe(values.total, true, 2, -9999999999999999) + '',
        discount: +formatPipe(values.discount, true, 2, -9999999999999999) + '',
        active: values.active !== undefined ? String(values.active) : 'true',
        c2pEnabled: false,
      }
      console.log('🚀 [Suscriptions] baseBody construido:', baseBody)
      console.log('🚀 [Suscriptions] baseBody.items:', baseBody.items)

      const finalBody = selectedSuscription
        ? { ...baseBody, items: values.items || [], id: selectedSuscription.id }
        : { ...baseBody, items: values.items || [] }

      console.log(
        '🚀 [Suscriptions] finalBody que se enviará al API:',
        finalBody
      )
      console.log('🚀 [Suscriptions] finalBody.items:', finalBody.items)
      console.log(
        '🚀 [Suscriptions] finalBody.items.length:',
        finalBody.items?.length
      )

      if (selectedSuscription) {
        // Modo edición: Enviar items
        console.log('🚀 [Suscriptions] Llamando PATCH con:', finalBody)
        const response = await axios.patch(`${server}/subscription`, finalBody)
        console.log('🚀 [Suscriptions] Respuesta del PATCH:', response.data)
      } else {
        // Modo creación: Enviar items
        console.log('🚀 [Suscriptions] Llamando POST con:', finalBody)
        const response = await axios.post(`${server}/subscription`, finalBody)
        console.log('🚀 [Suscriptions] Respuesta del POST:', response.data)
      }
      console.log(
        '🚀 [Suscriptions] ============================================'
      )
      addAlert({
        message:
          'Suscripción ' +
          (selectedSuscription ? 'editada' : 'creada') +
          ' satisfactoriamente',
        status: 'success',
      })

      await onGetSuscriptions()
      if (selectedSuscription) {
        setSelectedSuscription(null)
      }
      setModal(false)
    } catch (err) {
      addAlert({
        message:
          'Error al ' +
          (selectedSuscription ? 'editar' : 'crear') +
          ' la suscripción',
        status: 'error',
      })
    } finally {
      setIsLoadingForm(false)
    }
  }

  const onGetSuscriptions = async () => {
    setLoadingSuscription(true)
    const response = await axios.get<{ subscriptions: ISuscription[] }>(
      `${server}/subscription`
    )
    setSuscriptions(response.data.subscriptions)
    setLoadingSuscription(false)
  }

  useEffect(() => {
    // No cargar datos si es plan emprendedor
    if (!isEmprendedorUser) {
      onGetSuscriptions()
    }
  }, [isEmprendedorUser])

  const onDelete = async (suscription: ISuscription) => {
    try {
      addAlert({
        message: 'Eliminando suscripción...',
        status: 'loading',
      })
      await axios.delete(`${server}/subscription?id=${suscription.id}`)
      onGetSuscriptions()
      addAlert({
        message: 'Suscripción eliminada satisfactoriamente',
        status: 'success',
      })
      setSuscriptions(suscriptions.filter((s) => s.id !== suscription.id))
    } catch (err: any) {
      const errorMessage = err?.response?.data?.message || ''

      if (
        err?.response?.status === 400 &&
        errorMessage.includes('associated data')
      ) {
        addAlert({
          message:
            'No se puede eliminar una suscripción que tenga clientes asociados',
          status: 'error',
          duration: 7000,
        })
      } else {
        addAlert({
          message: 'Error al eliminar la suscripción',
          status: 'error',
        })
      }
    }
  }

  const onAddSubscriber = async (suscription: ISuscription) => {
    setSelectedSuscriptionToAddSubscriber(suscription)
    setAddSubscriberModal(true)
  }

  const onHandleAddSubscriber = async (values: {
    duration: string
    endDate: string
    startDate: string
    client: { id: string }
  }) => {
    const body = {
      chargeDay: +values.duration,
      endDate: dateToDB(values.endDate),
      startDate: dateToDB(values.startDate),
      clientId: +values.client.id,
      subscriptionId: +selectedSuscriptionToAddSubscriber.id,
    }
    try {
      setLoadingSubscriber(true)
      addAlert({
        message: 'Creando suscriptor...',
        status: 'loading',
      })
      await axios.post(`${server}/subscription/link-client`, body)
      await onGetSuscriptions()
      setAddSubscriberModal(false)
      addAlert({
        message: 'Suscriptor creado satisfactoriamente',
        status: 'success',
      })
    } catch (err) {
      addAlert({
        message: 'Error al crear suscriptor',
        status: 'error',
      })
    } finally {
      setLoadingSubscriber(false)
    }
  }

  if (loadingSuscription) {
    return (
      <div className="flex justify-center items-center h-full">
        <Loading />
      </div>
    )
  }

  // Mostrar mensaje de upgrade si es plan emprendedor
  if (isEmprendedorUser) {
    return (
      <div className="flex flex-col justify-center items-center h-full p-4">
        <div
          className="p-8 rounded-lg shadow-lg max-w-2xl text-center"
          style={{
            backgroundColor: theme === 'dark' ? '#1D1D1D' : '#FFFFFF',
            borderColor: theme === 'dark' ? '#2D2D2D' : '',
            borderWidth: theme === 'dark' ? 1 : 0,
          }}
        >
          <div className="mb-6">
            <FaFileInvoice
              className="mx-auto mb-4"
              size={64}
              style={{ color: '#507CDC' }}
            />
          </div>
          <h2 className="text-2xl font-bold mb-4 dark:text-white">
            Funcionalidad Premium
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-400 mb-6">
            Para gestionar suscripciones debes mejorar tu plan a{' '}
            <strong className="text-primary">"PYME"</strong>
          </p>
          <p className="text-sm text-gray-500 dark:text-gray-500">
            El plan Corporativo incluye gestión completa de suscripciones
            recurrentes, facturación automática, configuración de planes
            personalizados y mucho más.
          </p>
        </div>
      </div>
    )
  }

  const onEdit = async (suscription: ISuscription) => {
    setSelectedSuscription(suscription)
    setModal(true)
  }

  const onView = async (suscription: ISuscription) => {
    setSelectedSuscriptionToView(suscription)
    setViewModal(true)
  }

  return (
    <>
      <div>
        <div className="grid md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6 px-1">
          {suscriptions.map((suscription) => (
            <SuscriptionCard
              onView={onView}
              onEdit={onEdit}
              onDelete={onDelete}
              key={suscription.id}
              suscription={suscription}
              onAddSubscriber={onAddSubscriber}
              userRole={userRole}
            />
          ))}
        </div>
      </div>

      <Modal
        display={modal}
        // modalClasses="w-3/6 py-4 px-12"
        scroll="scroll"
        onAccept={() => null}
        onClose={() => {
          setModal(false)
          setSelectedSuscription(null)
        }}
        xlClasses="xl:w-6/12"
        innerStyle={{ width: '100%' }}
      >
        <SuscriptionForm
          defaultValues={selectedSuscription!}
          isLoadingForm={isLoadingForm}
          onCancel={() => {
            setModal(false)
            setSelectedSuscription(null)
          }}
          onSubmit={(values: any) => {
            onSubmit(values)
          }}
        />
      </Modal>

      <Modal
        display={viewModal}
        scroll="scroll"
        onAccept={() => null}
        onClose={() => {
          setViewModal(false)
          setSelectedSuscriptionToView(null)
        }}
        xlClasses="xl:w-6/12"
        innerStyle={{ width: '100%' }}
      >
        <SuscriptionView
          suscription={selectedSuscriptionToView!}
          onClose={() => {
            setViewModal(false)
            setSelectedSuscriptionToView(null)
          }}
        />
      </Modal>

      <Modal
        display={addSubscriberModal}
        // modalClasses="w-3/ 6 py-4 px-12"
        scroll="scroll"
        onAccept={() => null}
        onClose={() => {
          setAddSubscriberModal(false)
          // setSelected(null)
        }}
        xlClasses="xl:w-[700px]"
        innerStyle={{ width: '100%' }}
      >
        <AddSuscriberForm
          loadingSubscriber={loadingSubscriber}
          selectedSuscription={selectedSuscriptionToAddSubscriber}
          onCancel={() => setAddSubscriberModal(false)}
          onSubmit={(values) => {
            onHandleAddSubscriber(values)
          }}
        />
      </Modal>
    </>
  )
}

export default Suscriptions

interface SuscriptionsProps {
  setHeaderActions: React.Dispatch<
    React.SetStateAction<HeaderProps['headerActions'] | null | undefined>
  >
}
